import React, { useState, useEffect } from 'react';
import CategoryGrid from './CategoryGrid';
import CategoryTree from './CategoryTree';
import './Categories.css';

const Categories = ({ title, description }) => {
  const [viewMode, setViewMode] = useState('grid'); // 'grid' or 'tree'
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  // Detect mobile screen size and set default view to tree
  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (mobile) {
        setViewMode('tree'); // Force tree view on mobile
      }
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
    console.log('Selected category:', category);
    // You can add navigation or other actions here
  };

  // Default values
  const displayTitle = title || 'Browse Categories';
  const displayDescription = description || 'Discover digital services across various categories';

  return (
    <div className="categories-page">
      <div className="categories-header">
        <div className="container">
          <div className="categories-header-content">
            <div className="categories-title-section">
              <h1>{displayTitle}</h1>
              <p>{displayDescription}</p>
            </div>
            
            <div className="categories-controls">
              <div className="view-toggle">
                <button 
                  className={`view-btn ${viewMode === 'grid' ? 'active' : ''}`}
                  onClick={() => !isMobile && setViewMode('grid')}
                >
                  <i className="bi bi-grid-3x3-gap"></i>
                  Grid View
                </button>
                <button 
                  className={`view-btn ${viewMode === 'tree' ? 'active' : ''}`}
                  onClick={() => !isMobile && setViewMode('tree')}
                >
                  <i className="bi bi-diagram-3"></i>
                  Tree View
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="categories-content">
        <div className="container">
          {isMobile || viewMode === 'tree' ? (
            <div className="categories-tree-view">
              <CategoryTree
                onCategorySelect={handleCategorySelect}
                showIcons={true}
                showCounts={true}
                expandAll={false}
                className="full-width-tree"
              />
            </div>
          ) : (
            <div className="categories-grid-view">
              {/* Top 5 Featured Categories */}
              <CategoryGrid
                title="Top Categories"
                featured={true}
                size="large"
                showDescription={true}
                showSubCategories={false}
                limit={5}
                className="featured-categories"
                onCategorySelect={handleCategorySelect}
              />

              {/* View All Categories Button */}
              <div className="view-all-categories">
                <button 
                  className="view-all-btn"
                  onClick={() => window.open('/categories/all', '_blank')}
                >
                  <i className="bi bi-grid-3x3-gap"></i>
                  View All Categories
                  <i className="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
          )}

          {/* Selected Category Info */}
          {selectedCategory && (
            <>
              <div className="selected-category-overlay" onClick={() => setSelectedCategory(null)}></div>
              <div className="selected-category-info">
                <div className="selected-category-card">
                  <div className="selected-category-header">
                    <h3>Category Details</h3>
                    <button 
                      className="close-btn"
                      onClick={() => setSelectedCategory(null)}
                    >
                      <i className="bi bi-x"></i>
                    </button>
                  </div>
                  <div className="selected-category-content">
                    <div className="selected-category-icon">
                      {selectedCategory.icon ? (
                        <i className={selectedCategory.icon}></i>
                      ) : (
                        <i className="bi bi-tag"></i>
                      )}
                    </div>
                    <div className="selected-category-details">
                      <h4>{selectedCategory.name}</h4>
                      {selectedCategory.description && (
                        <p>{selectedCategory.description}</p>
                      )}
                      <div className="selected-category-meta">
                        <span className="level-badge">
                          Level {selectedCategory.level !== undefined ? selectedCategory.level : 'N/A'}
                        </span>
                        {selectedCategory.is_featured && (
                          <span className="featured-badge">
                            <i className="bi bi-star-fill"></i>
                            Featured
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Categories;